/* AIMALL FILTER STATE V1.3: Shopify may omit active facet values when a filtered query has zero results. */
(function () {
  'use strict';
  if (window.__aimallSearchFilterStateV13) return;
  window.__aimallSearchFilterStateV13 = true;
  function sync() {
    var root = document.querySelector('[data-aimall-search-page]');
    if (!root) return;
    var current = new URL(window.location.href);
    var active = false;
    current.searchParams.forEach(function (value, name) {
      if (name.indexOf('filter.') === 0 && value.trim() !== '') active = true;
    });
    if (!active) return;
    var state = root.querySelector('[data-aimall-search-state]');
    var total = Number(state ? state.dataset.total : root.dataset.results);
    root.dataset.hasFilters = 'true';
    if (state) state.dataset.hasFilters = 'true';
    var clear = new URL(root.dataset.clearUrl || current.href, current.origin);
    Array.from(clear.searchParams.keys()).forEach(function (name) {
      if (name.indexOf('filter.') === 0 || name === 'page') clear.searchParams.delete(name);
    });
    if (current.searchParams.get('aimall_broad') === '1') clear.searchParams.set('aimall_broad', '1');
    var status = root.querySelector('.aimall-search-status');
    if (status) {
      var count = status.querySelector('span');
      if (count && !count.textContent.includes('with your filters')) count.appendChild(document.createTextNode(' with your filters'));
      if (!status.querySelector('[data-aimall-search-clear]')) {
        var link = document.createElement('a');
        link.href = clear.href;
        link.dataset.aimallSearchClear = '';
        link.textContent = 'Clear filters';
        status.appendChild(link);
      }
    }
    var empty = root.querySelector('[data-aimall-search-empty]');
    if (total === 0 && empty) {
      var heading = empty.querySelector('h2');
      if (heading && heading.textContent !== 'No products match these filters') heading.textContent = 'No products match these filters';
      var intro = empty.querySelector('.aimall-search-empty__intro');
      var description = heading && heading.nextElementSibling;
      var message = 'Remove the filters to see products for “' + root.dataset.query + '”. Popular products below are other ideas, not matches for these filters.';
      if (description && description.tagName === 'P' && description.textContent !== message) description.textContent = message;
      if (intro && !intro.querySelector('[data-aimall-search-clear]')) {
        var paragraph = document.createElement('p');
        var reset = document.createElement('a');
        reset.href = clear.href;
        reset.dataset.aimallSearchClear = '';
        reset.textContent = 'Clear filters';
        paragraph.appendChild(reset);
        intro.insertBefore(paragraph, description ? description.nextSibling : null);
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
  var timer;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(sync, 30);
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('popstate', sync);
})();
